import { render, staticRenderFns } from "./IconSearches.vue?vue&type=template&id=2a82918c&"
import script from "./IconSearches.vue?vue&type=script&lang=js&"
export * from "./IconSearches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports